/* eslint-disable quote-props */
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Button from '../../../components/button';
import Typography from '../../../components/typography';
import ImageRedirectProfile from '../../../components/imageRedirectProfile';

import BillingDataMexico from './dataInvoicingData/Mexico';
import BillingDataColombia from './dataInvoicingData/Colombia';

import pencil from '../../../assets/images/profile-pencil-icon.svg';
import ArrowBack from '../../../assets/images/icon-arrow-back-color-primary.svg';

import './invoicingData.scss';

const InvoicingDataScreenScreen = () => {
  const isMobileDevice = useSelector((state) => state.mediaQuery.isMobileDevice);
  const user = useSelector((state) => state.auth.user);

  const navigate = useNavigate();

  const billingDataCountries = () => {
    switch (user.countryCode) {
      case '170':
        return (
          <BillingDataColombia
            user={user}
            isMobileDevice={isMobileDevice}
          />
        );
      case '484':
        return (
          <BillingDataMexico
            user={user}
            isMobileDevice={isMobileDevice}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div id="profile" className={isMobileDevice ? 'mobile-mode' : 'desktop-mode'}>
      <div className={`header-profile ${isMobileDevice ? 'mobile-mode' : 'desktop-mode'}`}>
        <div className="content-back">
          <ImageRedirectProfile src={ArrowBack} url="/perfil" />
          <Typography
            type="superTitle-italic"
            text="Datos de facturación"
            className="button-back"
          />
        </div>
        <div className="editButton">
          {isMobileDevice ? (
            <div>
              <ImageRedirectProfile
                src={pencil}
                url="/editar-perfil/datos-de-facturacion"
              />
            </div>
          ) : (
            <Button
              text="Editar"
              type="tertiary"
              onClick={() => navigate('/editar-perfil/datos-de-facturacion')}
            />
          )}
        </div>
      </div>
      <div className="profile">
        {billingDataCountries()}
      </div>
    </div>
  );
};

export default InvoicingDataScreenScreen;
